package com.speedsoftware.nibbler.ui.profile

/** Turns a User-Agent string into something like "Chrome on macOS". */
fun describeDevice(userAgent: String?): String {
    val ua = userAgent?.trim().orEmpty()
    if (ua.isEmpty()) return "Unknown device"
    if (ua.contains("ktor", ignoreCase = true) || ua.contains("nibbler", ignoreCase = true)) return "Nibbler app"

    val browser = when {
        "Edg/" in ua || "Edge/" in ua || "EdgA/" in ua || "EdgiOS/" in ua -> "Edge"
        "OPR/" in ua || "Opera" in ua -> "Opera"
        "Firefox/" in ua || "FxiOS/" in ua -> "Firefox"
        "Chrome/" in ua || "CriOS/" in ua -> "Chrome"
        "Safari/" in ua -> "Safari"
        else -> null
    }
    // iPhone / iPad / Android user agents also mention "Mac OS X" or "Linux", so they are checked first
    val os = when {
        "iPhone" in ua -> "iPhone"
        "iPad" in ua -> "iPad"
        "Android" in ua -> "Android"
        "Windows" in ua -> "Windows"
        "CrOS" in ua -> "ChromeOS"
        "Mac OS X" in ua || "Macintosh" in ua -> "macOS"
        "Linux" in ua || "X11" in ua -> "Linux"
        else -> null
    }
    return when {
        browser != null && os != null -> "$browser on $os"
        browser != null -> browser
        os != null -> os
        else -> "Unknown device"
    }
}

/** "just now", "5 minutes ago", "3 hours ago", "2 days ago". */
fun formatAgo(seconds: Long): String {
    fun unit(value: Long, name: String) = "$value $name${if (value == 1L) "" else "s"} ago"
    return when {
        seconds < 60 -> "just now"
        seconds < 3600 -> unit(seconds / 60, "minute")
        seconds < 86_400 -> unit(seconds / 3600, "hour")
        else -> unit(seconds / 86_400, "day")
    }
}
